import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vilka delar ingår i kunskapsprovet?";
const SHORT_ANSWER = "Alkohollag, servering, ordning och nykterhet, marknadsföring, tillsyn och sanktioner samt – för vissa typer – mat och köksregler.";

export const Route = createFileRoute("/fraga/vilka-delar-ingar-i-provet")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vilka delar ingår i kunskapsprovet" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Områdena anges i FoHMFS 2014:7 bilaga 1. Provet slumpar frågor inom varje område och du måste klara godkäntgränsen i varje del. Det är därför du inte kan kompensera med ett starkt område."}
      source={{ label: "FoHMFS 2014:7 – Föreskrifter om kunskapsprov", href: "https://www.folkhalsomyndigheten.se/publikationer-och-material/publikationsarkiv/f/fohmfs-20147/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/kunskapsprovet-exempelfragor", label: "Exempelfrågor från provet" }}
      related={[{"to": "/fraga/vad-ar-skillnad-stadigvarande-prov-tillfalligt", "label": "Vad är skillnaden mellan provet för stadigvarande och tillfälligt tillstånd?"}, {"to": "/fraga/galler-provet-i-alla-kommuner", "label": "Gäller godkänt kunskapsprov i alla kommuner?"}, {"to": "/fraga/behover-alla-i-ledningen-gora-provet", "label": "Behöver alla i ledningen göra kunskapsprovet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vilka delar ingår i kunskapsprovet?" },
      { name: "description", content: "Alkohollag, servering, ordning och nykterhet, marknadsföring, tillsyn och sanktioner samt – för vissa typer – mat och köksregler." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vilka-delar-ingar-i-provet" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vilka-delar-ingar-i-provet" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vilka-delar-ingar-i-provet",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vilka delar ingår i kunskapsprovet", url: "https://alkoholprovet.se/fraga/vilka-delar-ingar-i-provet" },
      ]),
    ],
  }),
});
